import { render } from "./DetailSlip.vue?vue&type=template&id=6e236493&scoped=true"
import script from "./DetailSlip.vue?vue&type=script&lang=js"
export * from "./DetailSlip.vue?vue&type=script&lang=js"

import "./DetailSlip.vue?vue&type=style&index=0&id=6e236493&scoped=true&lang=css"
import "./DetailSlip.vue?vue&type=style&index=1&id=6e236493&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e236493"]])

export default __exports__